import React from "react";
import Video from "../../assets/videos/hero-section/hero-video.mp4";
import "../../assets/css/home-page/hero.css";

export default function Hero({ onMenuClick }) {
  return (
    <section id="hero" className="hero-viewport">
      <video autoPlay loop muted playsInline className="hero-video-asset">
        <source src={Video} type="video/mp4" />
      </video>
      <div className="hero-scrim-overlay">
        <div className="container-fluid hero-content-wrapper">
          <div className="compliance-tag">
            Fully Compliant with IS 458 : 2003 Standards
          </div>
          <h1 className="hero-main-title">
            High-Performance Reinforced Cement Concrete (
            <span className="accent-text">RCC</span>) Pipes
          </h1>
          <p className="hero-descriptive-body">
            Engineered for high load-bearing capacity and resilience. We
            manufacture and distribute NP2, NP3, and NP4 class structural
            concrete pipes ranging from 150mm to 2400mm nominal bore sizes for
            major national highway networks, heavy industrial drainage
            infrastructure, and urban municipal sewerage systems.
          </p>
          <div className="hero-action-ctas">
            <button
              onClick={() => onMenuClick("products")}
              className="cta-btn-primary"
            >
              View Technical Specifications
            </button>
            <button
              onClick={() => onMenuClick("contact")}
              className="cta-btn-secondary"
            >
              Request Structural Estimate
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
